import { render, staticRenderFns } from "./applyIntranetBusiness.vue?vue&type=template&id=634eaa5f&scoped=true&lang=html"
import script from "./applyIntranetBusiness.vue?vue&type=script&lang=js"
export * from "./applyIntranetBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634eaa5f",
  null
  
)

export default component.exports